
import React from "react";
import { Label } from "@/components/ui/label";
import TagSelector from "../../attributes/TagSelector";
import { ProductAttribute } from "@/types/attributes";

interface ItemAttributesSectionProps {
  attributes: ProductAttribute[];
  onAttributeAdd: (attribute: ProductAttribute) => void;
  onAttributeRemove: (attributeId: string) => void;
  suggestedAttributes?: ProductAttribute[];
}

const ItemAttributesSection = ({ 
  attributes, 
  onAttributeAdd, 
  onAttributeRemove,
  suggestedAttributes = []
}: ItemAttributesSectionProps) => {
  return (
    <div className="space-y-2">
      <Label>Attributi</Label>
      <TagSelector
        attributes={attributes}
        onAttributeAdd={onAttributeAdd}
        onAttributeRemove={onAttributeRemove}
        suggestedAttributes={suggestedAttributes}
      />
    </div>
  );
};

export default ItemAttributesSection;
